import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	summaryContainer: {
		backgroundColor: colors.blue[50],
		borderRadius: 12,
		padding: 16,
		width: "100%"
	},
	summaryHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: 14
	},
	summaryTitle: {
		fontWeight: 400,
		fontSize: "13.5px",
		color: colors.blue[800],
		lineHeight: 1
	},
	summaryLines: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap",
		alignItems: "center",
		gap: 6,
		width: "100%"
	},
	templateWrapper: {
		width: "100%"
	},
	templateDivider: {
		display: "block",
		width: "100%",
		height: 1,
		backgroundColor: colors.blue[100],
		margin: "14px 0"
	},
	templateLabel: {
		width: "100%",
		textAlign: "left"
	},
	templateSection: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap",
		alignItems: "center",
		gap: 6,
		marginTop: 8,
		width: "100%"
	}
}))

export default useStyles
